import React from "react";
import { Manifesto } from "../components/Manifesto";
import { Martini } from "../components/Martini";

export default function ManifestoPage() {
  return (
    <main data-testid="manifesto-page" className="pt-16">
      <Manifesto />
      <Martini />
    </main>
  );
}
